import { afterNextRender, ChangeDetectionStrategy, Component, input, output, signal, viewChild } from '@angular/core';

import type { OptionalCookieCategories } from '@arya/gdpr/cookie-consent/domain';

import { NoxoButton, NoxoIconButton } from '@noxo/ui/button';
import { NoxoDialog, NoxoDialogActions, NoxoDialogHeader, NoxoDialogTitle } from '@noxo/ui/dialog';
import { NoxoIcon } from '@noxo/ui/icon';
import { NoxoSwitch } from '@noxo/ui/switch';

const NONE: OptionalCookieCategories = { functional: false, analytics: false, marketing: false };

@Component({
  selector: 'lib-cookie-consent-preferences-dialog',
  imports: [
    NoxoButton,
    NoxoDialog,
    NoxoDialogActions,
    NoxoDialogHeader,
    NoxoDialogTitle,
    NoxoIcon,
    NoxoIconButton,
    NoxoSwitch,
  ],
  templateUrl: './cookie-consent-preferences-dialog.html',
  styleUrl: './cookie-consent-preferences-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentPreferencesDialog {
  public readonly value = input.required<OptionalCookieCategories>();

  public readonly save = output<OptionalCookieCategories>();
  public readonly closed = output();

  private readonly dialog = viewChild.required(NoxoDialog);
  protected readonly draft = signal<OptionalCookieCategories>(NONE);

  constructor() {
    afterNextRender(() => {
      this.draft.set(this.value());
      this.dialog().showModal();
    });
  }

  protected set(category: keyof OptionalCookieCategories, checked: boolean): void {
    this.draft.update((draft) => ({ ...draft, [category]: checked }));
  }

  protected close(): void {
    this.dialog().close();
  }

  protected submit(categories: OptionalCookieCategories): void {
    this.save.emit(categories);
    this.close();
  }

  protected onlyNecessary(): void {
    this.submit(NONE);
  }
}
